import { getJson, UserRequestHeaders, saysWho } from './Util';
import Endpoints from '../Utils/Endpoints';
import { Auth } from '../Services';
import { GetErrorMessageWithEmailLink } from '../Components';

export class OfflineTemplateService {

    public static check = async (selectedLocation:any): Promise<boolean> => {
        return new Promise((resolve, reject) => {
            getJson(Endpoints.CheckForTemplate, undefined, undefined,  new UserRequestHeaders({ ...Auth.getUser(), Location: selectedLocation })).then((response) => {
                resolve(response);                 
            }).catch((e) => {
                reject(e);
            })
        })
    }

    public static upload = (e: any, resources: any, selectedLocation: any): Promise<any> => {
        //console.log("OfflineTemplateService upload");
        //console.log(e);
        return new Promise((resolve, reject) => {
            try {
                const files = e.target.files;
                if (!files || !files.length) {
                    //console.log("bad files");
                    //console.log(files)
                    reject({ cancel: true });
                    return;
                }

                if (!e.target.value.match(/(.vlx|.txt)+$/g)) {
                    reject(resources.Upload_WrongFormat);
                    return;
                }

                const file = files[0];
                const reader = new FileReader();
                let response;
                reader.onload = async event => {
                    const fileBody = event.target!["result"];
                    response = await getJson(Endpoints.UploadOfflineTemplate,
                        {
                            body: JSON.stringify(fileBody),
                            credentials: "include",
                            method: "post",
                            headers: {
                                "Accept": "application/json, application/xml, text/plain, text/html, *.*",
                                "Content-Type": "application/json;"
                            }
                        },
                        undefined,
                         new UserRequestHeaders({ ...Auth.getUser(), Location: selectedLocation }));
                    response = JSON.parse(response);
                    response.Success ? resolve(response) :
                        reject(GetErrorMessageWithEmailLink(response.Message, response.Email));//response.Email ? `${response.Message} <a href="mailto:${response.Email}">${response.Email}</a>` : response.Message);
                };
                reader.readAsText(file);
                // Reset file input element so onChange event fires
                e.target.value = null;
            } catch (ex) {
                console.error(`Error: ${ex}`);
                e.target.value = null;
            }
        });
    }

    public static download = (selectedLocation: any) => {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", Endpoints.DownloadOfflineTemplate, true);
        const fetchTokenAndSendRequest = async () => {
            var userRequestHeaders = new UserRequestHeaders(Auth.getUser());
            xhr.setRequestHeader(UserRequestHeaders.OrganisationKey, userRequestHeaders.Organisation);
            xhr.setRequestHeader(UserRequestHeaders.LocationKey, encodeURI(selectedLocation));
            xhr.setRequestHeader(UserRequestHeaders.UserIdKey, userRequestHeaders.UserId);
    
            try {
                const token = await Auth.getAccessToken();
                xhr.setRequestHeader("Authorization", `Bearer ${token}`);
            } catch (error) {
                console.error(`Error adding auth header: ${error}`);
            }
    
            xhr.responseType = 'blob';
            xhr.onload = function (this, event) {
                var blob = this.response;
                var contentDispo = this.getResponseHeader('Content-Disposition');
                var match = contentDispo?.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);            
                if (match) {
                    var fileName = match[1];
                    fileName = fileName.startsWith('_') || fileName.startsWith('"') ? fileName.slice(1) : fileName;
                    fileName = fileName.endsWith('_') || fileName.endsWith('"') ? fileName.slice(0, fileName.length - 1) : fileName;
    
                    if (saysWho().name == "IE") {
                        window.navigator.msSaveOrOpenBlob(blob, fileName);
                    } else {
                        var a = document.createElement('a');
                        a.href = window.URL.createObjectURL(blob);
                        a.download = fileName;
                        a.dispatchEvent(new MouseEvent('click'));
                    }
                } else {                
                    console.error("invalid fileName");
                    console.error(this.status);
                    console.error(this.responseText || this.response)
                }
            };
    
            xhr.send();
        };
    
        // Call the inner async function immediately
        fetchTokenAndSendRequest();
    }
}